<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from '@/composables/useI18n'
import { useAuth } from '@/composables/useAuth'
import { useFloatingUI } from '@/composables/useFloatingUI'

const { t } = useI18n()
const { adminUser, logout } = useAuth()

const isOpen = ref(false)
const buttonRef = ref<HTMLElement | null>(null)
const { floatingEl, floatingStyles } = useFloatingUI(buttonRef)

function toggle() {
  isOpen.value = !isOpen.value
}

function close() {
  isOpen.value = false
}

function onClickOutside(e: Event) {
  const el = (e.target as HTMLElement).closest('.admin-user')
  if (!el) close()
}

onMounted(() => document.addEventListener('click', onClickOutside))
onUnmounted(() => document.removeEventListener('click', onClickOutside))
</script>

<template>
  <div class="admin-user">
    <button ref="buttonRef" class="btn btn-ghost" type="button" :aria-expanded="isOpen" :aria-label="t('admin-user-menu')" @click.stop="toggle">
      <span class="icon icon-person" aria-hidden="true"></span>
      <span class="sr-only">{{ t('admin-user-menu') }}</span>
    </button>
    <div v-if="isOpen" ref="floatingEl" :style="floatingStyles" class="status-dropdown" role="region" :aria-label="t('admin-user-menu')">
      <div class="status-dropdown-content">
        <div class="admin-user-info">
          <div class="admin-user-name">{{ adminUser?.given_name }} {{ adminUser?.family_name }}</div>
          <div class="admin-user-email">{{ adminUser?.email }}</div>
        </div>
        <div class="admin-user-actions">
          <a href="#" class="admin-user-logout" @click.prevent="logout">
            <span class="icon icon-logout" aria-hidden="true"></span>
            <span>{{ t('admin-logout') }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
